import React, { useState, useEffect } from "react";
import StepCircle from "../StepCircle";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
} from "@mui/material";
import api from "../../api";

const steps = ["Detalles del Consumo", "Asignar Vehículo"];

const AgregarCombustible = ({ vehiculo, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);
  const [conductores, setConductores] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const [combustible, setCombustible] = useState({
    producto: "",
    litros_unidades: "",
    fecha_y_hora: "",
    domicilio: "",
    localidad: "",
    provincia: "",
    imp_tot_yer: "",
    vehiculo: "",
    conductor: "",
  });

  useEffect(() => {
    api.get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));

    api.get("conductores/")
      .then((response) => setConductores(response.data))
      .catch(() => alert("Error al cargar conductores."));
  }, []);

  useEffect(() => {
    if (vehiculo) {
      setCombustible((prev) => ({
        ...prev,
        vehiculo: vehiculo.id,
      }));
    }
  }, [vehiculo]);

  useEffect(() => {
    const {
      producto, litros_unidades, fecha_y_hora, domicilio,
      localidad, provincia, imp_tot_yer
    } = combustible;

    setIsStep1Valid(
      producto &&
      litros_unidades &&
      fecha_y_hora &&
      domicilio &&
      localidad &&
      provincia &&
      imp_tot_yer
    );
  }, [combustible]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCombustible((prev) => ({ ...prev, [name]: value }));
  };

  const handleNext = () => {
    if (vehiculo) {
      handleSubmit(new Event("submit"));
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();

    const litros = parseFloat(combustible.litros_unidades);
    const total = parseFloat(combustible.imp_tot_yer);

    if (isNaN(litros) || litros <= 0) {
      alert("La cantidad de litros ingresada no es válida.");
      return;
    }

    if (isNaN(total) || total <= 0) {
      alert("El importe total ingresado no es válido.");
      return;
    }

    const payload = {
      ...combustible,
      litros_unidades: litros,
      imp_tot_yer: total,
    };

    api.post("combustibles/", payload)
      .then((res) => {
        alert("Carga de combustible registrada correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch((error) => {
        if (error.response) {
          console.error("Error response:", error.response.data);
          alert("Error al registrar consumo: " + JSON.stringify(error.response.data));
        } else {
          console.error("Error:", error);
          alert("Error desconocido al registrar consumo.");
        }
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Agregar Consumo
      </Typography>

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <TextField
              label="Producto"
              name="producto"
              value={combustible.producto}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Litros (Unidades)"
              name="litros_unidades"
              type="number"
              value={combustible.litros_unidades}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Fecha y Hora"
              name="fecha_y_hora"
              type="datetime-local"
              value={combustible.fecha_y_hora}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Domicilio"
              name="domicilio"
              value={combustible.domicilio}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Localidad"
              name="localidad"
              value={combustible.localidad}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Provincia"
              name="provincia"
              value={combustible.provincia}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Importe Total (ARS)"
              name="imp_tot_yer"
              type="number"
              value={combustible.imp_tot_yer}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Conductor (opcional)</InputLabel>
              <Select
                name="conductor"
                value={combustible.conductor}
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value="">Sin conductor</MenuItem>
                {conductores.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nombre} {c.apellido}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              {vehiculo ? "Agregar Consumo" : "Siguiente"}
            </Button>
          </Grid>
        </Grid>
      )}

      {!vehiculo && step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo</InputLabel>
              <Select name="vehiculo" value={combustible.vehiculo} onChange={handleChange}>
                <MenuItem value="">Sin vehículo</MenuItem>
                {vehiculos.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.patente} - {v.marca} {v.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Agregar Consumo
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarCombustible;
